import React from 'react';
import { IfmsRoute }from '../../../config/types';

export const WhReceiptView = React.lazy(() => import("../receipt/WhReceiptView"));
export const WhReceivingView = React.lazy(() => import("../receiving/WhReceivingView"));
export const WhShippingView = React.lazy(() => import("../shipping/WhShippingView"));
const WhStorageInvoiceView = React.lazy(() => import("../storageInvoice/WhStorageInvoiceView"));
const WhCompanyView = React.lazy(() => import("../company/WhCompanyView"));
const WhItemView = React.lazy(() => import("../item/WhItemView"));
const WhLocView = React.lazy(() => import("../location/WhLocationView"));
const ReceiptLabelView = React.lazy(() => import("../../reports/ReceiptLabelView"));
const ReceivedCargoStatusView = React.lazy(() => import("../../reports/ReceivedCargoStatusView"));

const RcvBillingsView = React.lazy(() => import('../receiving/RecBillingsView'));
const ShpBillingsView = React.lazy(() => import('../shipping/ShpBillingsView'));

const PickupDeliveryView = React.lazy(() => import('../../reports/PickupDeliveryView')); //
const StraightBlView = React.lazy(() => import('../../reports/StraightBlView')); //

const QtyReportView = React.lazy(() => import('../reports/QtyReportView'));
const routes:Array<IfmsRoute> = [
  {path: '/warehousing/receipt/:mode/:id?/:tabIndex?/:createEntity?', component: WhReceiptView},
  {path: '/warehousing/receiving/:mode/:id?/:tabIndex?/:createEntity?/:opAcctIds?', component: WhReceivingView},
  {path: '/warehousing/shipping/:mode/:id?/:tabIndex?/:createEntity?/:opAcctIds?', component: WhShippingView},
  {path: '/warehousing/storageInvoice/:mode/:id?', component: WhStorageInvoiceView},
  {path: '/warehousing/company/:mode/:id?', component: WhCompanyView},
  {path: '/warehousing/item/:mode/:id?', component: WhItemView},
  {path: '/warehousing/loc/:mode/:id?', component: WhLocView},
  {path: '/warehousing/viewBillings/receiving/:id?', component: RcvBillingsView},
  {path: '/warehousing/viewBillings/shipping/:id?', component: ShpBillingsView},

   //MoreMenu
   { path: '/warehousing/pickupDelivery', component: PickupDeliveryView },
   { path: '/warehousing/straightBl', component: StraightBlView },

   { path: '/warehousing/chargeItemSummary', component: QtyReportView },
   { path: '/warehousing/customerInNOut', component: QtyReportView },
   //Freight Receipt MoreMenu
   { path: '/warehousing/receiptLabel', component: ReceiptLabelView },
   { path: '/warehousing/receivedcargostatus', component: ReceivedCargoStatusView },

];

export default routes;
